module.exports = __webpack_public_path__ + "static/media/02 Generali produkcja zwierzęca Karta produktu.c12c0b0e.pdf";